import { useQuery } from '@tanstack/react-query';
import { createAnnouncementsApi } from '../api/announcements.api';
import { auth } from '@core/utils/firebase/firebase';
import type { Auth } from '@angular/fire/auth';
import type { Announcement } from '@core/interfaces/api';

const api = createAnnouncementsApi(auth as Auth);

export function useAnnouncementsByBulkId(
  bulkId: string | undefined,
  options?: { enabled?: boolean },
) {
  return useQuery<Announcement[]>({
    queryKey: ['announcements-bulk', bulkId],
    queryFn: async () => {
      if (!bulkId) return [] as unknown as Announcement[];
      return api.getAnnouncementsByBulkId(bulkId);
    },
    enabled: Boolean(bulkId) && (options?.enabled ?? true),
    staleTime: 60_000,
  });
}

